/* Custom JS for pages only (Liquid Allowed)*/

(function($){

})(jQuery);